import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";

export const Row = styled.div<{ status?: boolean }>`
  ${FLEX.FlexStartCenter};
  gap: 8px;

  ${({ status }) =>
    status &&
    `
    color: ${COLORS.SELECTED}
  `}

  img {
    width: 18px;
  }
`;

export const RecorderRow = styled.div<{ status?: boolean; level?: LEVEL_TYPE }>`
  color: ${({ theme, status }) =>
    !status ? COLORS.LIGHTGRAY : theme.COLORS.WHITE};
  ${({ level }) =>
    level === LEVEL_TYPE.CP ? FLEX.FlexCenterCenter : FLEX.FlexStartCenter};
  gap: 4px;

  .bubble-container {
    position: relative;
    ${FLEX.FlexCenterCenter};
    color: ${({ theme, status }) =>
      !status ? COLORS.LIGHTGRAY : theme.COLORS.WHITE};
  }
`;
